import type { PublicEventsKey } from '@/i18n/dictionaries/publicEvents';
import type { PublicHomeKey } from '@/i18n/dictionaries/publicHome';
import type { EventKind } from '@/features/publicsite/types/events/EventKind';

/** ToR §6.11's activity types — the filter's "tip de activitate", and every event's `kind`. */
export const EVENT_KIND = {
  demonstration: 'DEMONSTRATION',
  visit: 'VISIT',
  workshop: 'WORKSHOP',
  conference: 'CONFERENCE',
  trainingEvent: 'TRAINING_EVENT',
  scientific: 'SCIENTIFIC',
} as const;

/** The six event kinds the calendar filter offers, in the order the public dictionary lists
 * them — a local list rather than i18n/eventKindLabels.ts, whose shorter wording is the
 * cabinet's own (see this dictionary's own top-of-file note on why the two are kept separate). */
export const EVENT_KINDS: EventKind[] = Object.values(EVENT_KIND);

/** Whether a code from a URL or the server is one of the six kinds. */
export function isEventKind(value: string): value is EventKind {
  return Object.values<string>(EVENT_KIND).includes(value);
}

/**
 * Each kind's label in publicEvents: the filter's options, a calendar row's category line and an
 * event page's eyebrow. A map rather than `kind${code}` built at runtime, so a kind with no label
 * is a compile error instead of its key printed on the page.
 */
export const EVENT_KIND_LABEL: Record<EventKind, PublicEventsKey & PublicHomeKey> = {
  DEMONSTRATION: 'kindDEMONSTRATION',
  VISIT: 'kindVISIT',
  WORKSHOP: 'kindWORKSHOP',
  CONFERENCE: 'kindCONFERENCE',
  TRAINING_EVENT: 'kindTRAINING_EVENT',
  SCIENTIFIC: 'kindSCIENTIFIC',
};
